import React, {useEffect, useState} from 'react'
import TableSearchBar from '../../../../reusable-components/tables/TableSearchBar'
import {useHistory, useLocation, useParams} from 'react-router-dom'
import {useSelector} from 'react-redux'
import {QueryData} from '../../../../reusable-components/tables/DynamicTableTypes'
import {RootState} from '../../../../../setup'
import axios from 'axios'
import dayjs from 'dayjs'
import TableTitle from '../../../../reusable-components/tables/TableTitle'
import TableWrapper from '../../../../reusable-components/tables/TableWrapper'
import DynamicTable from '../../../../reusable-components/tables/DynamicTable'
import {
  NOTES_ENTRIES_COLUMNS,
  NOTES_ENTRIES_COLUMNS_DATA_MAPPING,
  NOTES_ENTRIES_SORTING_COLUMNS,
} from '../../../caregiver/NOTES_TABLE_CONSTANTS'
const selectTimeZone = (state: RootState) => state.timeZone.timeZone

const DeletedCaregiverNotesList = () => {
  const location = useLocation()
  const [filteredData, setFilteredData] = useState([])
  const [isFetchingData, setIsFetchingData] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const queryParams = new URLSearchParams(location.search)
  const noteType = queryParams.get('noteType')
  const timeZone = useSelector(selectTimeZone)
  const [queryData, setQueryData] = useState<QueryData>({
    pageNumber: 1,
    pageSize: 5,
    currentPage: 1,
    totalCounts: 1,
    sortBy: '_id',
    sortDir: 'desc',
    searchTerm: '',
  })
  const params: {id: string} = useParams()
  const history = useHistory()
  
  useEffect(() => {
    const fetchData = async () => {
      setIsFetchingData(true);
      try {
        await new Promise((resolve) => setTimeout(resolve, 3000));

        await getNoteAndNoteEntriesDetail(
          queryData.pageNumber,
          queryData.pageSize,
          queryData.sortBy,
          queryData.sortDir,
          queryData.searchTerm
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsFetchingData(false);
      }
    };
  
    fetchData();
  }, [queryData.pageNumber, queryData.pageSize, queryData.sortBy, queryData.sortDir, queryData.searchTerm]);

  const getNoteAndNoteEntriesDetail = async (page: number, pageSize: number, sortBy: string, sortDir: string, searchTerm: string) => {
    try {
      setIsFetchingData(true)
      const noteEntriesPromise = await axios.get(
        `/notesEntry/getAll?noteId=${params.id}&page=${page}&pageSize=${pageSize}&sortBy=${sortBy}&sortDir=${sortDir}&searchTerm=${searchTerm}`
      );
  
      const { data: allEntries, currentPage, totalCounts } = noteEntriesPromise.data;
        const formattedEntries = allEntries.map((entry) => ({
      ...entry,
      beginTime: entry.beginTime
        ? dayjs.utc(entry.beginTime).tz(timeZone, true).format('MM-DD-YYYY')
        : 'No details provided',
      endTime: entry.endTime
        ? dayjs.utc(entry.endTime).tz(timeZone, true).format('MM-DD-YYYY')
        : 'No details provided',
    }));
      setFilteredData(formattedEntries);
      setQueryData((prevState) => ({
        ...prevState,
        currentPage,
        totalCounts,
      }));
    } catch (error) {
      console.error("Error fetching note and entries:", error);
    }finally{
      setIsFetchingData(false)
    }
  };
  const onUpdate = (row) => {
    history.push(`/deleted-notes/caregiver-notes/notesEntries/entry/${row._id}`)
  }
  return (
    <div className='card'>
      <div className='card-body'>
        <TableTitle title='Deleted Caregiver Notes'></TableTitle>
        <TableWrapper
          searchField={
            <TableSearchBar
              label='Search'
              variant='outlined'
              size='small'
              value={searchTerm}
              setQueryData={setQueryData}
              setSearchTerm={setSearchTerm}
              margin='normal'
              inputAdornmentPosition='start'
            ></TableSearchBar>
          }
          tableButtons={[]}
          dynamicTable={
            <DynamicTable
              queryData={queryData}
              setQueryData={setQueryData}
              htmlColumns={[]}
              canUpdate={true}
              onUpdate={onUpdate}
              columns={NOTES_ENTRIES_COLUMNS}
              sortingColumns={NOTES_ENTRIES_SORTING_COLUMNS}
              data={filteredData}
              columnDataMapping={NOTES_ENTRIES_COLUMNS_DATA_MAPPING}
              tableLoader={isFetchingData}
            />
          }
        />
      </div>
    </div>
  )
}

export default DeletedCaregiverNotesList
